import {
	login,
	getUserInfo
} from '@/apis/auth'
import {
	setToken,
	getToken
} from '@/libs/util'

export default {
	state: {
		userName: '微信用户',
		userId: '',
		userPhone: '暂无',
		avatorImgPath: '../../../static/img/default_doctor_img.png',
		token: getToken(),
	},
	mutations: {
		setAvator(state, avatorPath) {
			state.avatorImgPath = avatorPath
		},
		setUserId(state, id) {
			state.userId = id
		},
		setUserName(state, name) {
			state.userName = name
		},
		setToken(state, token) {
			state.token = token
			setToken(token)
		}
	},
	actions: {
		// 登录
		handleLogin({
			commit
		}, {
			code
		}) {
			return new Promise((resolve, reject) => {
				login(code).then(res => {
					const data = res.data.data;
					if (res.data.code !== 0) {
						reject(res.data);
						return;
					}
					commit('setToken', data.openid);
					commit('setUserId', data.openid);
					commit('setUserName', data.nickname);
					commit('setAvator', data.headimgurl);
					resolve();
				}).catch(err => {
					reject(err)
				})
			})
		},
		// 获取用户相关信息
		loadUserInfo({
			state,
			commit
		}) {
			if (state.userId) {
				return new Promise((resolve, reject) => {
					resolve({
						code:0,
						data:{
							openid:state.userId,
							nickname:state.userName,
							headimgurl:state.avator
						}
					});
				});
			}

			return new Promise((resolve, reject) => {
				getUserInfo().then(res => {
					const data = res.data.data;
					if (res.data.code !== 0) {
						reject(res.data);
						return;
					}
					if (!data.openid) {
						commit('setToken', undefined);
					}
					commit('setUserId', data.openid);
					commit('setUserName', data.nickname);
					commit('setAvator', data.headimgurl);
					resolve(data)
				}).catch(err => {
					reject(err)
				})
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/module/user.js